import {animate, style, transition, trigger} from '@angular/animations';

const animationDuration = '400ms';
const animationDurationFast = '200ms';

export const smoothShowHideHeight = trigger('smoothShowHideHeight', [
  transition(':enter', [
    style({ height: 0, opacity: 0}),
    animate(
      `${animationDuration} ease-in-out`,
      style({ height: '*', opacity: 1})
    )
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1}),
    animate(
      `${animationDuration} ease-in-out`,
      style({ height: 0, opacity: 0})
    )
  ])
]);

export const smoothShowHideWidth = trigger('smoothShowHideWidth', [
  transition(':enter', [
    style({ width: '20px', opacity: 0, transform: 'translateX(-20px)'}),
    animate(
      `${animationDuration} ease-in-out`,
      style({ width: '*', opacity: 1, transform: 'translateX(0)'})
    )
  ]),
  transition(':leave', [
    style({ width: '*', opacity: 1, transform: 'translateX(-0)'}),
    animate(
      `${animationDurationFast} ease-in-out`,
      style({ width: '20px', opacity: 0, transform: 'translateX(-20px)'})
    )
  ])
]);
